function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

/* eslint-disable no-console */
import { datadogLogs } from '@datadog/browser-logs';
import { DATADOG_CONFIG } from './config';
/**
 * @class Logger
 * @classdesc Logs to datadog and in a development enviroment also `console.log`s. It passes along optional `context`.
 */

var _log = /*#__PURE__*/_classPrivateFieldLooseKey("log");

var _datadogInit = /*#__PURE__*/_classPrivateFieldLooseKey("datadogInit");

var _datadogEnabled = /*#__PURE__*/_classPrivateFieldLooseKey("datadogEnabled");

var Logger = /*#__PURE__*/function () {
  /**
  * Constructs a new Logger
  * @param {string} [params.datadogClientToken=null] Datadog client_token
  * @param {object} [params.context={}] Additional data to pass along with each log method
  */
  function Logger() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$datadogClientTok = _ref.datadogClientToken,
        datadogClientToken = _ref$datadogClientTok === void 0 ? null : _ref$datadogClientTok,
        _ref$context = _ref.context,
        context = _ref$context === void 0 ? {} : _ref$context,
        _ref$enableConsole = _ref.enableConsole,
        enableConsole = _ref$enableConsole === void 0 ? false : _ref$enableConsole;

    _classCallCheck(this, Logger);

    Object.defineProperty(this, _datadogEnabled, {
      value: _datadogEnabled2
    });
    Object.defineProperty(this, _datadogInit, {
      value: _datadogInit2
    });
    Object.defineProperty(this, _log, {
      value: _log2
    });
    this.datadogClientToken = datadogClientToken;
    this.context = context;
    this.enableConsole = enableConsole;

    _classPrivateFieldLooseBase(this, _datadogInit)[_datadogInit]();
  }
  /**
  * Info logger
  * @param {string} message
  * @param {object}
  */


  _createClass(Logger, [{
    key: "info",
    value: function info() {
      var _classPrivateFieldLoo;

      for (var _len = arguments.length, all = new Array(_len), _key = 0; _key < _len; _key++) {
        all[_key] = arguments[_key];
      }

      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _log))[_log].apply(_classPrivateFieldLoo, ['info'].concat(all));
    }
    /**
    * Debug logger
    * @param {string} message
    * @param {object}
    */

  }, {
    key: "debug",
    value: function debug() {
      var _classPrivateFieldLoo2;

      for (var _len2 = arguments.length, all = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        all[_key2] = arguments[_key2];
      }

      (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _log))[_log].apply(_classPrivateFieldLoo2, ['debug'].concat(all));
    }
    /**
    * Warn logger
    * @param {string} message
    * @param {object}
    */

  }, {
    key: "warn",
    value: function warn() {
      var _classPrivateFieldLoo3;

      for (var _len3 = arguments.length, all = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        all[_key3] = arguments[_key3];
      }

      (_classPrivateFieldLoo3 = _classPrivateFieldLooseBase(this, _log))[_log].apply(_classPrivateFieldLoo3, ['warn'].concat(all));
    }
    /**
    * Error logger
    * @param {string} message
    * @param {object}
    */

  }, {
    key: "error",
    value: function error() {
      var _classPrivateFieldLoo4;

      for (var _len4 = arguments.length, all = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        all[_key4] = arguments[_key4];
      }

      (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _log))[_log].apply(_classPrivateFieldLoo4, ['error'].concat(all));
    }
  }]);

  return Logger;
}();

function _log2(level, message) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var payload = {
    kj_uploader_details: data,
    kj_uploader_context: this.context
  };
  if (_classPrivateFieldLooseBase(this, _datadogEnabled)[_datadogEnabled]()) datadogLogs.logger[level](message, payload);

  if (process.env.NODE_ENV === 'development' || this.enableConsole) {
    console[level]('%c[kj-uploader]', 'color: pink;', message, payload);
  }
}

function _datadogInit2() {
  if (!_classPrivateFieldLooseBase(this, _datadogEnabled)[_datadogEnabled]()) return;
  datadogLogs.init(_objectSpread({
    clientToken: this.datadogClientToken
  }, DATADOG_CONFIG));
}

function _datadogEnabled2() {
  return !!this.datadogClientToken;
}

export default Logger;